"use client";

import { c as _c } from "react/compiler-runtime";
import { BlogDigest } from "@/components/terra/layouts/BlogDigest/BlogDigest";
import { usePathname, useRouter } from "next/navigation";
export const BlogDigestWrapper = formattedBlogDigest => {
  const $ = _c(7);
  const router = useRouter();
  const pathname = usePathname();
  let t0;
  if ($[0] !== formattedBlogDigest.searchFilter || $[1] !== pathname || $[2] !== router) {
    t0 = value => {
      const params = new URLSearchParams(window.location.search);
      params.set("search", value);
      if (formattedBlogDigest?.searchFilter) {
        params.set("searchFilter", formattedBlogDigest.searchFilter);
      }
      router?.push(`${pathname}?${params.toString()}`);
    };
    $[0] = formattedBlogDigest.searchFilter;
    $[1] = pathname;
    $[2] = router;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleSearch = t0;
  const t1 = formattedBlogDigest?.showSearch ? handleSearch : undefined;
  let t2;
  if ($[4] !== formattedBlogDigest || $[5] !== t1) {
    const digestInput = {
      ...formattedBlogDigest,
      onSearch: t1
    };
    t2 = <BlogDigest {...digestInput} />;
    $[4] = formattedBlogDigest;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};